<template>
  <button class="btn-icon grey-to-blue formula" @click.self="$emit('click', $event)" :disabled="disabled">
    <icon class="florin"></icon>
    <span class="sr-only">Formula Button</span>
  </button>
</template>

<script lang="ts">
  import Vue from "vue";
  import disabledMixin from '~/mixins/disabledMixin'

  export default Vue.extend({
    mixins: [
      disabledMixin
    ],
  });
</script>
